import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum AccrualImporterGroupBy {
    DOCUMENT = "document",
    COUNTERPARTY = "counterparty",
    LINE_ITEM = "lineItem",
}

export enum AccrualImporterColumn {
    DATE_IMPORTED = "dateImported",
    STATUS = "status",
    DOCUMENT_DATE = "documentDate",
    DUE_DATE = "dueDate",
    NUMBER = "number",
    COUNTERPARTY = "counterparty",
    ITEM = "item",
    DESCRIPTION = "description",
    ACCRUAL_ACCOUNT = "accrualAccount",
    BALANCE_ACCOUNT = "balanceAccount",
    TOTAL = "total",
    ENTITY = "entity",
    ACTIONS = "actions",
}

export const AccrualImporterViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.ACCRUAL_IMPORTER),
    columns: z.array(
        ColumnSchema.extend({
            id: z.nativeEnum(AccrualImporterColumn),
        }),
    ),
    groupBy: z.nativeEnum(AccrualImporterGroupBy).optional(),
});

export type AccrualImporterView = z.infer<typeof AccrualImporterViewSchema>;
